export const Logo = ({ compact = false }) => (
  <img
    src="/assets/lendx-logo.png"
    alt="LendX — Your Preferred Lending Partner"
    data-testid="lendx-logo"
    className={compact ? "h-9 w-auto" : "h-11 w-auto md:h-12"}
  />
);
